/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as WebhookHealthIndexRouteImport } from './../routes/webhook-health/index'
import { Route as UsersIndexRouteImport } from './../routes/users/index'
import { Route as SupportActionsIndexRouteImport } from './../routes/support-actions/index'
import { Route as SettingsIndexRouteImport } from './../routes/settings/index'
import { Route as ReclaimsIndexRouteImport } from './../routes/reclaims/index'
import { Route as MembershipsIndexRouteImport } from './../routes/memberships/index'
import { Route as HardwareIndexRouteImport } from './../routes/hardware/index'
import { Route as GiftsIndexRouteImport } from './../routes/gifts/index'
import { Route as FulfillmentIndexRouteImport } from './../routes/fulfillment/index'
import { Route as FraudIndexRouteImport } from './../routes/fraud/index'
import { Route as DunningNoticesIndexRouteImport } from './../routes/dunning-notices/index'
import { Route as DisputesIndexRouteImport } from './../routes/disputes/index'
import { Route as AuditLogsIndexRouteImport } from './../routes/audit-logs/index'
import { Route as UsersUserIdRouteImport } from './../routes/users/$userId'
import { Route as ReportsGiftObligationsRouteImport } from './../routes/reports/gift-obligations'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhookHealthIndexRoute = WebhookHealthIndexRouteImport.update({
  id: '/webhook-health/',
  path: '/webhook-health/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportActionsIndexRoute = SupportActionsIndexRouteImport.update({
  id: '/support-actions/',
  path: '/support-actions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReclaimsIndexRoute = ReclaimsIndexRouteImport.update({
  id: '/reclaims/',
  path: '/reclaims/',
  getParentRoute: () => rootRouteImport,
} as any)
const MembershipsIndexRoute = MembershipsIndexRouteImport.update({
  id: '/memberships/',
  path: '/memberships/',
  getParentRoute: () => rootRouteImport,
} as any)
const HardwareIndexRoute = HardwareIndexRouteImport.update({
  id: '/hardware/',
  path: '/hardware/',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftsIndexRoute = GiftsIndexRouteImport.update({
  id: '/gifts/',
  path: '/gifts/',
  getParentRoute: () => rootRouteImport,
} as any)
const FulfillmentIndexRoute = FulfillmentIndexRouteImport.update({
  id: '/fulfillment/',
  path: '/fulfillment/',
  getParentRoute: () => rootRouteImport,
} as any)
const FraudIndexRoute = FraudIndexRouteImport.update({
  id: '/fraud/',
  path: '/fraud/',
  getParentRoute: () => rootRouteImport,
} as any)
const DunningNoticesIndexRoute = DunningNoticesIndexRouteImport.update({
  id: '/dunning-notices/',
  path: '/dunning-notices/',
  getParentRoute: () => rootRouteImport,
} as any)
const DisputesIndexRoute = DisputesIndexRouteImport.update({
  id: '/disputes/',
  path: '/disputes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogsIndexRoute = AuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsGiftObligationsRoute = ReportsGiftObligationsRouteImport.update({
  id: '/reports/gift-obligations',
  path: '/reports/gift-obligations',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reports/gift-obligations': typeof ReportsGiftObligationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/audit-logs/': typeof AuditLogsIndexRoute
  '/disputes/': typeof DisputesIndexRoute
  '/dunning-notices/': typeof DunningNoticesIndexRoute
  '/fraud/': typeof FraudIndexRoute
  '/fulfillment/': typeof FulfillmentIndexRoute
  '/gifts/': typeof GiftsIndexRoute
  '/hardware/': typeof HardwareIndexRoute
  '/memberships/': typeof MembershipsIndexRoute
  '/reclaims/': typeof ReclaimsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/support-actions/': typeof SupportActionsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/webhook-health/': typeof WebhookHealthIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reports/gift-obligations': typeof ReportsGiftObligationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/audit-logs': typeof AuditLogsIndexRoute
  '/disputes': typeof DisputesIndexRoute
  '/dunning-notices': typeof DunningNoticesIndexRoute
  '/fraud': typeof FraudIndexRoute
  '/fulfillment': typeof FulfillmentIndexRoute
  '/gifts': typeof GiftsIndexRoute
  '/hardware': typeof HardwareIndexRoute
  '/memberships': typeof MembershipsIndexRoute
  '/reclaims': typeof ReclaimsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/support-actions': typeof SupportActionsIndexRoute
  '/users': typeof UsersIndexRoute
  '/webhook-health': typeof WebhookHealthIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/reports/gift-obligations': typeof ReportsGiftObligationsRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/audit-logs/': typeof AuditLogsIndexRoute
  '/disputes/': typeof DisputesIndexRoute
  '/dunning-notices/': typeof DunningNoticesIndexRoute
  '/fraud/': typeof FraudIndexRoute
  '/fulfillment/': typeof FulfillmentIndexRoute
  '/gifts/': typeof GiftsIndexRoute
  '/hardware/': typeof HardwareIndexRoute
  '/memberships/': typeof MembershipsIndexRoute
  '/reclaims/': typeof ReclaimsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/support-actions/': typeof SupportActionsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/webhook-health/': typeof WebhookHealthIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reports/gift-obligations'
    | '/users/$userId'
    | '/audit-logs/'
    | '/disputes/'
    | '/dunning-notices/'
    | '/fraud/'
    | '/fulfillment/'
    | '/gifts/'
    | '/hardware/'
    | '/memberships/'
    | '/reclaims/'
    | '/settings/'
    | '/support-actions/'
    | '/users/'
    | '/webhook-health/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/reports/gift-obligations'
    | '/users/$userId'
    | '/audit-logs'
    | '/disputes'
    | '/dunning-notices'
    | '/fraud'
    | '/fulfillment'
    | '/gifts'
    | '/hardware'
    | '/memberships'
    | '/reclaims'
    | '/settings'
    | '/support-actions'
    | '/users'
    | '/webhook-health'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/reports/gift-obligations'
    | '/users/$userId'
    | '/audit-logs/'
    | '/disputes/'
    | '/dunning-notices/'
    | '/fraud/'
    | '/fulfillment/'
    | '/gifts/'
    | '/hardware/'
    | '/memberships/'
    | '/reclaims/'
    | '/settings/'
    | '/support-actions/'
    | '/users/'
    | '/webhook-health/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ReportsGiftObligationsRoute: typeof ReportsGiftObligationsRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  AuditLogsIndexRoute: typeof AuditLogsIndexRoute
  DisputesIndexRoute: typeof DisputesIndexRoute
  DunningNoticesIndexRoute: typeof DunningNoticesIndexRoute
  FraudIndexRoute: typeof FraudIndexRoute
  FulfillmentIndexRoute: typeof FulfillmentIndexRoute
  GiftsIndexRoute: typeof GiftsIndexRoute
  HardwareIndexRoute: typeof HardwareIndexRoute
  MembershipsIndexRoute: typeof MembershipsIndexRoute
  ReclaimsIndexRoute: typeof ReclaimsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SupportActionsIndexRoute: typeof SupportActionsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  WebhookHealthIndexRoute: typeof WebhookHealthIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhook-health/': {
      id: '/webhook-health/'
      path: '/webhook-health'
      fullPath: '/webhook-health/'
      preLoaderRoute: typeof WebhookHealthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support-actions/': {
      id: '/support-actions/'
      path: '/support-actions'
      fullPath: '/support-actions/'
      preLoaderRoute: typeof SupportActionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reclaims/': {
      id: '/reclaims/'
      path: '/reclaims'
      fullPath: '/reclaims/'
      preLoaderRoute: typeof ReclaimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memberships/': {
      id: '/memberships/'
      path: '/memberships'
      fullPath: '/memberships/'
      preLoaderRoute: typeof MembershipsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hardware/': {
      id: '/hardware/'
      path: '/hardware'
      fullPath: '/hardware/'
      preLoaderRoute: typeof HardwareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gifts/': {
      id: '/gifts/'
      path: '/gifts'
      fullPath: '/gifts/'
      preLoaderRoute: typeof GiftsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fulfillment/': {
      id: '/fulfillment/'
      path: '/fulfillment'
      fullPath: '/fulfillment/'
      preLoaderRoute: typeof FulfillmentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fraud/': {
      id: '/fraud/'
      path: '/fraud'
      fullPath: '/fraud/'
      preLoaderRoute: typeof FraudIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dunning-notices/': {
      id: '/dunning-notices/'
      path: '/dunning-notices'
      fullPath: '/dunning-notices/'
      preLoaderRoute: typeof DunningNoticesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/disputes/': {
      id: '/disputes/'
      path: '/disputes'
      fullPath: '/disputes/'
      preLoaderRoute: typeof DisputesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-logs/': {
      id: '/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs/'
      preLoaderRoute: typeof AuditLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/gift-obligations': {
      id: '/reports/gift-obligations'
      path: '/reports/gift-obligations'
      fullPath: '/reports/gift-obligations'
      preLoaderRoute: typeof ReportsGiftObligationsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ReportsGiftObligationsRoute: ReportsGiftObligationsRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  AuditLogsIndexRoute: AuditLogsIndexRoute,
  DisputesIndexRoute: DisputesIndexRoute,
  DunningNoticesIndexRoute: DunningNoticesIndexRoute,
  FraudIndexRoute: FraudIndexRoute,
  FulfillmentIndexRoute: FulfillmentIndexRoute,
  GiftsIndexRoute: GiftsIndexRoute,
  HardwareIndexRoute: HardwareIndexRoute,
  MembershipsIndexRoute: MembershipsIndexRoute,
  ReclaimsIndexRoute: ReclaimsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SupportActionsIndexRoute: SupportActionsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  WebhookHealthIndexRoute: WebhookHealthIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
